export interface ParsedWireAction {
    method: 'post' | 'get';
    serializeSelector: string;
    loadingTag: string;
    action: string;
    params: string;
    fragmentTag: string;

    formData?: FormData;
    rawGet?: string
}

/**
 * action:params - akcja:JSON
 *
 * action:params
 * @get:#loadingTag:action:params
 *
 * #loadingTag:action:params
 * @post:#loadingTag:action:params
 *
 * @post:action:param
 * @post(.closest-selector-to-serialize):action:param
 *
 * >fragment-tag:@post:action:param
 *
 * @param attr
 * @protected
 */
export default function wireActionParse(type: string, attr: string): ParsedWireAction {

    let parts: string[];

    let sepIndex = attr.indexOf(":");

    if (attr.indexOf(":") > 0) {

        let splitted = reverse(attr.split(":"));

        let isGet = true;
        let postSelectorVal = '';
        let loadingTagVal = '';
        let fragmentTag = '';

        let actionVal = splitted[1];
        let paramsVal = splitted[0];

        if (splitted.length > 2) {

            for (let i = 2; i < splitted.length; i++) {
                let v = splitted[i];

                if(v.indexOf('@') === 0){
                    let httpmethod = v;

                    if (httpmethod.indexOf('(') > 0) {
                        let halfs = splitInHalf('(', httpmethod);
                        let selector = halfs[1].replace(')', '');

                        if (selector.trim().length > 0) {
                            postSelectorVal = selector.trim();
                        }
                    }

                    if (httpmethod.indexOf('@post') >= 0) {
                        isGet = false;
                    }
                }

                if(v.indexOf('#') === 0){
                    loadingTagVal = v.substr(1);
                }

                if(v.indexOf('$') === 0){
                    fragmentTag = v.substr(1);
                }

            }



        } else {

            if (type == 'submit') {
                isGet = false;
            }

        }


        return {
            method: isGet ? 'get' : 'post',
            serializeSelector: postSelectorVal,
            loadingTag: loadingTagVal,
            action: actionVal,
            params: paramsVal,
            fragmentTag: fragmentTag
        }

    } else {
        throw new Error("Bad formatted action: " + attr);
    }

}

function reverse(arr: string[]): string[] {
    let n: string[] = [];

    arr.forEach(e => {
        n.unshift(e);
    });
    return n;
}

function splitInHalf(char: string, s: string): string[] {

    let sepIndex = s.indexOf(char);

    if (!sepIndex) {
        return [s, ""];
    }

    return [
        s.slice(0, sepIndex),
        s.slice(sepIndex + 1)
    ];

}